import Router from 'vue-router'
import { getAuthState, store } from './index'
// const subPage = {
//   template: '<router-view></router-view>'
// }

export default class extends Router {
  constructor (arg) {
    super(arg)
    this.map({
      '/login': {
        component: require('./components/pages/Login.vue'),
        noauth: true
        // noloading: true
      },
      '/products': {
        component: require('./components/pages/Products.vue')
      },
      '/firmware': {
        name: 'firmware',
        component: require('./components/pages/Firmware.vue')
      },
      '/privateMIB': {
        component: require('./components/pages/Private_MIB_V2.vue')
      },
      '/license': {
        component: require('./components/pages/License.vue')
      },
      '/documentation': {
        component: require('./components/pages/Documentation.vue')
      },
      '/instaviewer': {
        name: 'instaviewer',
        component: require('./components/pages/Viewer.vue')
      },
      '/faq': {
        name: 'faq',
        component: require('./components/pages/FAQ.vue')
      },
      // '/mt-download': {
      //   component: require('./components/pages/FirmwareDownload.vue')
      // }
    })
    this.beforeEach(({ to, next, abort }) => {
      if (to.matched === null) {
        getAuthState().then(state => {
          abort()
          if (state) {
            const target = '/firmware'
            this.replace(target)
          } else {
            this.replace('/login')
          }
        })
      } else if (to.noauth) {
        next()
      } else {
        getAuthState().then(state => {
          if (state) {
            // if ((store.state.user.role === 'manufacturer' && to.path !== "/mt-download")) {
            //   abort()
            //   this.replace('/mt-download')
            // }
            if (to.path === '/documentation' && !['admin', 'salesperson'].includes(store.state.user.role)) {
              abort()
              this.replace('/firmware')
            }
            return next()
          }
          abort()
          this.replace('/login')
        })
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/Router.js